import { EVENT_COLOR_CLASSES } from "../shared";

const LEGEND = [
  { c: "blue", label: "Vendor intro · to book" },
  { c: "dark-blue", label: "Vendor intro booked" },
  { c: "purple", label: "Couple intro · to book" },
  { c: "dark-purple", label: "couple intro booked" },
  { c: "red", label: "Vendor Consultation" },
  { c: "gold", label: "Custom / held" },
  { c: "orange", label: "Consultation" },
];

const CalendarLegend = () => (
  <div className="mt-4 flex items-center flex-wrap gap-x-5 gap-y-2">
    {LEGEND.map(({ c, label }) => (
      <span
        key={c}
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)]"
      >
        <span
          className={"h-2 w-2 rounded-full " + EVENT_COLOR_CLASSES[c].dot}
        />
        {label}
      </span>
    ))}
  </div>
);

export default CalendarLegend;
